import type {SSEDataAdapter} from "./SSEDataAdapter.js";
import {DefaultSSEDataAdapter} from "./DefaultSSEDataAdapter.js";
import type {OnSSEConnectListener} from "../listener/OnSSEConnectListener.js";


export default class SSEClient {

    private client: EventSource | null = null
    private adapter: SSEDataAdapter = new DefaultSSEDataAdapter()
    private urlStr: string
    private connectListener: OnSSEConnectListener[] = []

    private EVENT_TYPE_SUCCESS = "success"
    private EVENT_TYPE_ERROR = "error"
    private EVENT_END_MSG = "end"

    constructor(url: URL) {

        this.urlStr = url.toString()

    }

    public registerConnectionListener(listener: OnSSEConnectListener) {

        this.connectListener.push(listener)

    }

    public connect() {

        if (this.connectListener.length > 0) {
            for (let i = this.connectListener.length - 1; i >= 0; i--) {

                this.connectListener[i]?.onSSEConnect()

            }
        }

        this.client = new EventSource(this.urlStr);
        this.client.addEventListener(this.EVENT_TYPE_SUCCESS, (e) => {

            if(e.data === this.EVENT_END_MSG) {
                this.adapter!.on_end_msg(this);
            }else {
                this.adapter!.on_success_msg(e.data);
            }

        })

        this.client.addEventListener(this.EVENT_TYPE_ERROR, (e) => {

            this.adapter!.on_error_msg(e.data);
            this.close()

        })

    }

    public registerAdapter(adapter: SSEDataAdapter) {
        this.adapter = adapter
    }

    public close() {
        this.client?.close()
        if (this.connectListener.length > 0) {
            for (let i = this.connectListener.length - 1; i >= 0; i--) {

                this.connectListener[i]?.onClose()

            }
        }
    }

}